// import backendIP from './serverData';

// // Function to get audio file
// export async function getAudio(filenameWithPath, callback) {
//     try {
//         console.log(filenameWithPath)
//         const response = await fetch(`${backendIP}/audio/getaudio`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({ filenameWithPath }),
       
//         });

//         if (response.ok) { 
//             const blob = await response.blob();
//             const audioUrl = URL.createObjectURL(blob);
//             callback(audioUrl);
//         } else {
//             console.error('Failed to fetch audio file:', response.statusText);
//             callback(null);
//         }
//     } catch (error) {
//         console.error('Error fetching audio file:', error);
//         callback(null);
//     }
// }

// export async function checkResource(folderPath) {
//     try {
//         console.log(folderPath)
//         const response = await fetch(`${backendIP}/audio/checkresource`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({ folderPath }),
//         });
//         console.log(response)
//         if (!response.ok) {
//             console.error('Failed to fetch audio files:', response.statusText);
//             return false; // Ensure it returns false on failure
//         }

//         const data = await response.json();
//         return data; // Ensure backend sends { exists: true/false }
//     } catch (error) {
//         console.error('Error fetching audio files:', error);
//         return false; // Return false on error
//     }
// }


import backendIP from './serverData';

// Utility function to normalize folder paths
// export function normalizeFolderPath(path) {
//     // Remove leading/trailing slashes and replace multiple slashes with one
//     return path.replace(/\/+/g, '/').replace(/^\/|\/$/g, '');
// }
export function normalizeFolderPath(path) {
  if (!path) return '';
  return '/' + path.replace(/\/+/g, '/').replace(/^\/|\/$/g, '');
}

// Utility function to get parent folder path
export function getParentFolderPath(path) {
    const normalized = normalizeFolderPath(path);
    const parts = normalized.split('/');
    parts.pop(); // Remove last segment
    return parts.join('/');
}

// Function to get audio file
export async function getAudio(filenameWithPath, callback) {
    try {
        console.log(filenameWithPath)
        const response = await fetch(`${backendIP}/audio/getaudio`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ filenameWithPath }),
        });

        if (response.ok) { 
            const blob = await response.blob();
            const audioUrl = URL.createObjectURL(blob);
            callback(audioUrl);
        } else {
            console.error('Failed to fetch audio file:', response.statusText);
            callback(null);
        }
    } catch (error) {
        console.error('Error fetching audio file:', error);
        callback(null);
    }
}

export async function checkResource(folderPath) {
    try {
        // Normalize folderPath to avoid double segments or slashes
        const sanitizedFolderPath = normalizeFolderPath(folderPath);
        console.log(sanitizedFolderPath)
        const response = await fetch(`${backendIP}/audio/checkresource`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ folderPath: sanitizedFolderPath }),
        });
        console.log(response)
        if (!response.ok) {
            console.error('Failed to fetch audio files:', response.statusText);
            return false; // Ensure it returns false on failure
        }

        const data = await response.json();
        return data; // Ensure backend sends { exists: true/false }
    } catch (error) {
        console.error('Error fetching audio files:', error);
        return false; // Return false on error
    }
}